import { IBetsByServicesModelItem } from '../../../../repositories/auction/v1/get-bets-position';
import { IBetPosition } from '../../../../types/reducers/betPosition';

export function mapBetPosition(betPosition: IBetsByServicesModelItem): IBetPosition {
  const { page, offerPosition } = betPosition;

  return {
    page: page || null,
    offerPosition: offerPosition || null,
  };
}
